const TAG_COLOR_CLASSES: Record<string, string> = {
  yellow: "viz-categorical-01-subtle viz-categorical-01-text",
  indigo: "viz-categorical-02-subtle viz-categorical-02-text",
  lime: "viz-categorical-03-subtle viz-categorical-03-text",
  pink: "viz-categorical-04-subtle viz-categorical-04-text",
  cyan: "viz-categorical-05-subtle viz-categorical-05-text",
  primary: "surface-brand-subtle content-action-brand",
  gray: "surface-neutral-subtle content-action-neutral",
  info: "surface-info-subtle content-action-info",
  notice: "surface-notice-subtle content-action-notice",
  positive: "surface-positive-subtle content-action-positive",
  negative: "surface-negative-subtle content-action-negative",
};

export function getTagClasses(color?: string): string {
  return TAG_COLOR_CLASSES[color ?? ""] ?? "surface-neutral-subtle content-action-neutral";
}
